/* 英語などの画面だけで読む：テーマに直接書いた日本語（ホームの独自の枠など。Shopifyの翻訳では訳せない所）を英語に置き換える
   2026-10-15 神城。snippets/eh-locale.liquid が日本語以外の画面でだけ読み込む。日本語の画面には一切関係しない。
   ・文字の置き換えだけ（金額・リンク・商品は変えない）。お客様の声の本文・お名前・商品名は原文のまま
   ・「文字のかたまり全体が一致した時だけ」置き換える。同じ日本語でも場所で訳が変わる物は場所（class）で分ける
   ・あとから差し込まれる枠（お客様の声など）にも効くよう、画面の変化を見て都度かける */
(function () {
  if (window.__ehI18n) return;
  window.__ehI18n = true;

  var ANY = {
    'お客様の声': 'Customer Voices', '見る': 'View',
    'ネックレス': 'Necklaces', 'テニスチェーン': 'Tennis Chains', 'モアサナイト': 'Moissanite', '時計': 'Watches',
    'ブレスレット': 'Bracelets', 'ペンダント': 'Pendants', 'ピアス': 'Earrings', 'リング': 'Rings', '人気商品': 'Best Sellers',
    '色:': 'Color:', 'コレクション': 'Collections',
    'ルールを詳しく見る': 'See the full rules',
    '写真付きのお声': 'Reviews with photos', 'すべて': 'All', 'お客様の写真': 'Customer photos',
    '並び順': 'Sort by', '新しい順': 'Newest', '評価が高い順': 'Highest rated', '評価が低い順': 'Lowest rated',
    '続きを読む': 'Read more', 'すべての声を見る': 'See all reviews',
    'お客様の写真つきのお声はまだありません。': 'No reviews with customer photos yet.',
    '星のないお声（DM・メールでいただいた感想）は平均評価に含めず、評価順では末尾に表示します。':
      'Reviews without stars (sent to us by DM or email) are not counted in the average and appear last when sorted by rating. Reviews are shown in the original Japanese.',
    '世界に一つだけの': 'One of a kind:', 'オリジナルジュエリー': 'custom jewelry',
    'あなたの想いを、熟練の職人が唯一無二のピースへ。これまでの制作実績をご覧ください。':
      'Skilled artisans turn your idea into a one-of-a-kind piece. See what we have made so far.',
    '無料で相談する': 'Free consultation',
    '店舗一覧': 'Our Stores',
    '全国のEMPIRE HOLLYWOODで、その輝きを直接お確かめください。各店舗をタップするとGoogle Mapが開きます。':
      'See the shine in person at EMPIRE HOLLYWOOD stores across Japan. Tap a store to open Google Maps.',
    '大阪店': 'Osaka', '名古屋店': 'Nagoya', '札幌（北広島）店': 'Sapporo (Kitahiroshima)', '十勝本店': 'Tokachi Main Store',
    'Google Mapで見る': 'Open in Google Maps',
    'モアサナイトのすべてを、宝石のプロが解説。': 'Everything about moissanite, explained by gem pros.',
    'ダイヤモンドとの違い、後悔しない選び方。読めば、きっと欲しくなる。': 'How it differs from diamond, and how to choose with no regrets. Read it and you will want one.',
    '記事を読む': 'Read the article',
    'カラーを選ぶ': 'Choose color', 'ホワイトゴールド': 'White Gold', 'ゴールド': 'Gold',
    'よく一緒に購入されている商品': 'Frequently bought together', '商品詳細': 'Product details',
    'あわせておすすめ': 'You may also like', '最近見た商品': 'Recently viewed',
    'ブランドアンバサダーにご興味はありませんか？': 'Interested in becoming a brand ambassador?',
    'empirehollywood.kanri@gmail.com までお気軽にお問い合わせください。': 'Feel free to contact us at empirehollywood.kanri@gmail.com.',
    'お問い合わせ': 'Contact us', '各SNSで最新情報を発信中。ぜひフォローしてください。': 'Follow us on social media for the latest news.',
    '3点': '3 items', 'PICK UP ITEMS (おすすめ)': 'PICK UP ITEMS', '全ての商品': 'All Products',
    '輝きも、着け心地も。お客様から届いたリアルな声をご紹介します。': 'The shine, the comfort: real words from our customers.',
    'レビューを書く': 'Write a review', '入荷したら通知する': 'Notify me when available',
    'ブランドの舞台裏や、未発表アイテムをLookBookでご紹介します。': 'Behind the scenes and unreleased pieces, in our LookBook.'
  };
  /* 場所で訳を分ける物（ホームの「2点購入で、1点無料」の説明） */
  var SCOPED = [
    ['.eh2b-title', { '2点購入で、': 'Buy 2, ', '1点無料': 'get 1 FREE' }],
    ['.eh2b-lead', { 'お好きな商品を': 'Add any ', '3点': '3 items', 'カートに追加すると、自動的に': ' to your cart and ',
      '1点（最安値）': 'the lowest-priced one', 'が': ' becomes ', '無料': 'FREE', 'になります。': ' automatically.' }],
    ['.eh2b-stxt', { 'お好きな商品を': 'Choose your', 'えらぶ': 'favorites', 'カートに': 'Add them', '追加する': 'to your cart',
      '1点（最安値）が': 'The lowest-priced one is', '自動で ¥0': 'automatically FREE' }]
  ];
  var PATTERNS = [
    [/^星評価 (\d+)件 \/ 全(\d+)件のお声$/, '$1 star ratings / $2 reviews in total'],
    [/^(\d)つ星 (\d+)件 (\d+%)$/, '$1 stars $2 $3'],
    [/^(\d+)件を表示中$/, 'Showing $1']
  ];
  var SKIP = '.ehv__txt,.ehv__src,.ehv__by,.ehv__prod,script,style,noscript,template,textarea,#EhlPanel';
  var JP = /[぀-ヿ一-鿿]/;

  function tr(node) {
    var raw = node.nodeValue;
    if (!raw || !JP.test(raw)) return;
    var el = node.parentElement;
    if (!el || el.closest(SKIP)) return;
    var t = raw.trim(), out = null, i;
    for (i = 0; i < SCOPED.length && out === null; i++) {
      if (el.closest(SCOPED[i][0]) && Object.prototype.hasOwnProperty.call(SCOPED[i][1], t)) out = SCOPED[i][1][t];
    }
    if (out === null && Object.prototype.hasOwnProperty.call(ANY, t)) out = ANY[t];
    for (i = 0; i < PATTERNS.length && out === null; i++) {
      if (PATTERNS[i][0].test(t)) out = t.replace(PATTERNS[i][0], PATTERNS[i][1]);
    }
    if (out === null) return;
    var lead = raw.match(/^\s*/)[0], tail = raw.match(/\s*$/)[0];
    node.nodeValue = lead + out + tail;
  }
  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { tr(root); return; }
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) tr(n);
  }
  var pending = [], scheduled = false;
  function flush() {
    scheduled = false;
    var list = pending; pending = [];
    for (var i = 0; i < list.length; i++) walk(list[i]);
  }
  function run() {
    /* 9/27 に終わった STACK PACK セールの枠（円の計算入りの日本語）が英語の画面にだけ残って出ていたため、英語などの画面では出さない（日本語の画面には元から出ていない） */
    var st = document.createElement('style');
    st.textContent = '[class^="ehsp"],[class*=" ehsp"]{display:none!important}';
    document.head.appendChild(st);
    walk(document.body);
    if (!window.MutationObserver) return;
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        if (ms[i].type === 'characterData') pending.push(ms[i].target);
        else for (var k = 0; k < ms[i].addedNodes.length; k++) pending.push(ms[i].addedNodes[k]);
      }
      if (!scheduled && pending.length) { scheduled = true; (window.requestAnimationFrame || setTimeout)(flush); }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
